import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountCreationComponent } from './pages/account-creation/account-creation.component';
import { CustomerInformationRoutingModule } from './customer-information-routing.module';
import { RiskResultPageComponent } from './pages/risk-result-page/risk-result-page.component';

import { CoreModule } from 'src/app/core/core.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { FatcaPepPageComponent } from './pages/fatca-pep-page/fatca-pep-page.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ConfirmationPageComponent } from './pages/confirmation-page/confirmation-page.component';




@NgModule({
  declarations: [
    AccountCreationComponent,
    RiskResultPageComponent,
    FatcaPepPageComponent,
    ConfirmationPageComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    CustomerInformationRoutingModule,
    CoreModule,
    SharedModule
  ]
})
export class CustomerInformationModule { }
